<template>
  <Row>
    <i-col span="24">
        <div style="width:100%;height:650px;" id="home_page_map"></div>
    </i-col>
  </Row>
</template>

<script>
import echarts from 'echarts'
import geoData from '../map-data/get-geography-value.js'
export default {
  name: 'homeMap',
  props: {
    cityData: Array,
    showType: Number
  },
  data () {
    return {
      map: null
    }
  },
  mounted () {
    let _this = this

    const chinaJson = require('../map-data/china.json')
    var resizeMap = echarts.init(document.getElementById('home_page_map'))
    this.map = resizeMap
    echarts.registerMap('china', chinaJson)
    this.initMap()
    this.map.on('click', function (param) {
      if (param.marker !== undefined) {
        if (param.seriesIndex === 1 || param.value[3] === 0) {
          // window.location.href = '/information'
        } else if (param.name === '无锡') {
          _this.$emit('showLayoutModalLogin')
        } else {
          window.location.href = '/publish/' + param.value[3]
        }
      }
    })

    window.addEventListener('resize', function () {
      resizeMap.resize()
    })
  },
  methods: {
    convertData: function (data, isRed) {
      let res = []
      let len = data.length
      for (var i = 0; i < len; i++) {
        if (isRed === data[i].show) {
          var geoCoord = geoData[data[i].name]
          if (geoCoord) {
            var resValue = geoCoord.concat(data[i].value)
            resValue = resValue.concat(data[i].cityCode)
            res.push({
              name: data[i].name,
              value: resValue
            })
          }
        }
      }

      return res
    },
    initMap: function () {
      let title = ''
      let subTitle = ''
      if (this.showType === 0) {
        title = '全国地铁城市分布图'
        subTitle = '请点击地图圆形图标查看城市投放案例或行业资讯'
      } else {
        title = '全国路面媒体洽谈城市分布图'
        subTitle = ''
      }

      this.map.setOption({
        backgroundColor: '#FFF',
        title: {
          text: title,
          subtext: subTitle,
          left: 'center',
          top: 50
        },
        legend: {
          data: ['已正式上线的城市', '洽谈中的城市'],
          bottom: 30
        },
        geo: {
          map: 'china',
          label: {
            emphasis: {
              show: false
            }
          },
          itemStyle: {
            normal: {
              areaColor: '#EFEFEF',
              borderColor: '#CCC'
            },
            emphasis: {
              areaColor: '#E5E5E5'
            }
          }
        },
        grid: {
          top: 0,
          left: '2%',
          right: '2%',
          bottom: '0',
          containLabel: true
        },
        series: [
          {
            // 显示已经上平台的地铁线路图标
            name: '已正式上线的城市',
            type: 'effectScatter',
            coordinateSystem: 'geo',
            data: this.convertData(this.cityData, true),
            symbolSize: function (val) {
              return val[2] / 7
            },
            showEffectOn: 'render',
            rippleEffect: {
              brushType: 'stroke'
            },
            hoverAnimation: true,
            label: {
              normal: {
                formatter: '{b}',
                position: 'bottom',
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#e84c3d',
                shadowBlur: 10,
                shadowColor: '#333'
              }
            },
            zlevel: 1
          },
          {
            // 蓝色小图标
            name: '洽谈中的城市',
            type: 'scatter',
            coordinateSystem: 'geo',
            data: this.convertData(this.cityData, false),
            symbolSize: function (val) {
              return val[2] / 7
            },
            label: {
              normal: {
                formatter: '{b}',
                position: 'right',
                show: false
              },
              emphasis: {
                show: true
              }
            },
            itemStyle: {
              normal: {
                color: '#B0B0B0'
              }
            }
          }
        ]
      })
    }
  },
  watch: {
    cityData (val) {
      this.initMap()
    }
  }
}
</script>
